import React from 'react'
import CandidateDetails from '../candidate-details'

const EditCandidateView = () => {
    return (
        <div>
            <div
                className={'container'}
                style={{
                    zIndex: 10,
                    minHeight: '100vh',
                    padding: '35px',
                }}
            >
                <CandidateDetails />
            </div>
        </div>
    )
}

export default EditCandidateView
